"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModificationRequestItemType = void 0;
const immutable_1 = require("immutable");
const User_1 = require("../User");
const ModificationRequestIssue_1 = require("./ModificationRequestIssue");
class ModificationRequestItem {
    constructor({ id, type, typeName, body, bucketId, assetIds, metadata, issue, sender, }) {
        this.toJSON = () => ({
            id: this.id,
            type: this.type ? this.type : null,
            typeName: this.typeName ? this.typeName : null,
            body: this.body,
            assetIds: this.assetIds.toJSON(),
            metadata: this.metadata,
            issue: this.issue ? this.issue.toJSON() : null,
            sender: this.sender.toJSON(),
        });
        this.id = id;
        this.type = type;
        this.typeName = typeName;
        this.body = body;
        this.bucketId = bucketId;
        this.assetIds = assetIds;
        this.metadata = metadata;
        this.issue = issue;
        this.sender = sender;
    }
}
ModificationRequestItem.fromJSON = (json) => {
    const { id, type, typeName, body, bucketId, assetIds, metadata, issue, sender } = Object.assign({}, json);
    if (id !== null && typeof id !== 'string')
        throw new Error('.id must be a string');
    if (type !== null && typeof type !== 'number')
        throw new Error('.type must be a number');
    if (typeName !== null && typeof typeName !== 'string')
        throw new Error('.typeName must be a string');
    if (typeof body !== 'string')
        throw new Error('.body must be a string');
    if (bucketId && typeof bucketId !== 'string')
        throw new Error('.bucketId must be a string');
    if (!Array.isArray(assetIds))
        throw new Error('.assetIds must be an array');
    if (typeof metadata !== 'object')
        throw new Error('.metadata must be an object');
    const _type = type ? deserializeToModificationRequestItemType(type) : null;
    return new ModificationRequestItem({
        id,
        type: _type,
        typeName: typeName ? typeName : null,
        body,
        bucketId,
        assetIds: immutable_1.List(assetIds),
        metadata,
        issue: issue ? ModificationRequestIssue_1.default.fromJSON(issue) : null,
        sender: User_1.DirectorUser.fromJSON(sender),
    });
};
const deserializeToModificationRequestItemType = (type) => {
    if (exports.ModificationRequestItemType.slice(1).indexOf(type) === -1) {
        throw new Error(`.type must be a one of ${exports.ModificationRequestItemType.slice(1).join(', ')}`);
    }
    return type;
};
exports.ModificationRequestItemType = [undefined, 1, 2, 3, 4, 5, 6];
exports.default = ModificationRequestItem;
